import { FormControl, FormLabel } from '@chakra-ui/react';
import { useExternalGetDistinctStatusesQuery } from '@client/graphql/__generated__/main-operations';
import { Select } from '@document/common/Select';
import { FC, useMemo } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';

interface StatusOption {
  label: string;
  value: string;
}

export const StatusFilter: FC = () => {
  const { statusFilter, setStatusFilter, organizationId } =
    useOrganizationCompliancePage();

  // Fetch distinct status values for the organization
  const { data: statusesData, loading } = useExternalGetDistinctStatusesQuery({
    variables: {
      input: {
        organizationId: organizationId!,
      },
    },
    skip: !organizationId,
  });

  // Convert status values to options
  const statusOptions: StatusOption[] = useMemo(() => {
    if (!statusesData?.externalGetDistinctStatuses) return [];

    return statusesData.externalGetDistinctStatuses.map((status) => ({
      label: status,
      value: status,
    }));
  }, [statusesData]);

  // Find the selected options
  const selectedOptions = statusFilter
    ? statusOptions.filter((option) => statusFilter.includes(option.value))
    : [];

  return (
    <FormControl>
      <FormLabel>Status</FormLabel>
      <Select
        isClearable
        isMulti
        isLoading={loading}
        options={statusOptions}
        placeholder="All statuses"
        size="sm"
        styles={{
          container: (provided) => ({
            ...provided,
            minWidth: 150,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        value={selectedOptions}
        onChange={(options) =>
          setStatusFilter(
            options && options.length > 0
              ? options.map((option) => option.value)
              : null
          )
        }
      />
    </FormControl>
  );
};
